<template>
  <slot v-if="productResponse && selectedOffer" :productResponse :selectedOffer>
    <Seller
      v-if="hasNoVariants"
      :category="productResponse.type"
      :selected-offer
    />
  </slot>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Seller from '~/scopes/product-core/components/presentationals/Seller/Seller.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { data: pickersResponse, selectedOffer } = useFetchPickers()

const hasNoVariants = computed(() => {
  return pickersResponse.value?.pickerGroups.length === 0
})
</script>
